export default "<p>rss-feed works!</p>\n<app-search #sp></app-search>\n\n"